import { Timeline } from 'react-twitter-widgets'
import ReactGA from 'react-ga4'

import { useState } from 'react'
export const Footer = () => {
    const [email, setEmail] = useState('')
    return (
        <>
            <div className='flex flex-col lg:flex-row justify-between mx-auto mt-20 max-w-[900px] gap-16'>
               
                <div className='w-full flex flex-col mx-auto lg:ml-auto pt-12 md:pt-0 px-4'>
                   
                    <div className='mailchimp lg:mt-12 xl:mt-20 w-full mx-auto'>
                        <form
                            action='https://nisamerica.us11.list-manage.com/subscribe/post?u=e8fc423eff95099d1ffcc6009&amp;id=349f7d20f9'
                            method='post'
                            id='mc-embedded-subscribe-form'
                            name='mc-embedded-subscribe-form'
                            className='validate'
                            target='_blank'
                            noValidate=''
                            onsubmit="ga('send', 'event', 'Mailchimp', 'Submit', 'Signup Form');"
                        >
                            <div id='mc_embed_signup_scroll' className='mailchimp text-center '>
                                <div>
                                    <p
                                        htmlFor='mce-EMAIL'
                                        className='text-navy font-bold text-sm md:text-base mt-8 mx-auto text-shadow-black w-full xl:w-4/5'
                                        for='search'
                                    >
                                        Subscribe to our mailing list to get the latest information!
                                    </p>
                                </div>
                                <div className='bg-orange rounded-lg w-full xl:w-4/5 mx-auto'>
                                    <label className='subscribe-wrapper'>
                                        <input
                                            className='font-bold'
                                            type='email'
                                            placeholder='Your Email'
                                            value={email}
                                            name='b_e8fc423eff95099d1ffcc6009_349f7d20f9'
                                            // name='EMAIL'
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        <button
                                            className='px-8 text-white font-bold'
                                            onClick={() => {
                                                ReactGA.event({
                                                    action: 'click',
                                                    event: 'link',
                                                    category: 'Socials',
                                                    label: `NIS Subscribe Newsletter`,
                                                })
                                            }}
                                        >
                                            Subscribe
                                        </button>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className='pb-8 flex flex-row items-center md:my-4 gap-4 justify-center'>
                        <div className='max-w-[40px]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social Icons',
                                        label: `NIS Twitter`,
                                    })
                                }}
                                href='https://twitter.com/nisamerica'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Twitter'
                            >
                                <img
                                    className='w-full'
                                    src={`${process.env.PUBLIC_URL}/images/sns-05.png`}
                                    alt='twitter icon'
                                />
                            </a>
                        </div>
                        <div className='max-w-[40px]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social Icons',
                                        label: `NIS Facebook`,
                                    })
                                }}
                                href='https://www.facebook.com/NISAmericaInc/'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Facebook'
                            >
                                <img
                                    className='w-full'
                                    src={`${process.env.PUBLIC_URL}/images/sns-02.png`}
                                    alt='facebook icon'
                                />
                            </a>
                        </div>
                        <div className='max-w-[40px]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social Icons',
                                        label: `NIS Instagram`,
                                    })
                                }}
                                href='https://www.instagram.com/nisamerica/'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Instagram'
                            >
                                <img
                                    className='w-full'
                                    src={`${process.env.PUBLIC_URL}/images/sns-07.png`}
                                    alt='ig icon'
                                />
                            </a>
                        </div>
                        <div className='max-w-[40px]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social Icons',
                                        label: `NIS YouTube`,
                                    })
                                }}
                                href='https://www.youtube.com/user/NISAmerica'
                                target='_blank'
                                rel='noreferrer'
                                data-label='YouTube'
                            >
                                <img
                                    className='w-full'
                                    src={`${process.env.PUBLIC_URL}/images/sns-01.png`}
                                    alt='youtube icon'
                                />
                            </a>
                        </div>
                        <div className='max-w-[40px]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social Icons',
                                        label: `NIS Twitch`,
                                    })
                                }}
                                href='https://www.twitch.tv/nisamerica'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Twitch'
                            >
                                <img
                                    className='w-full'
                                    src={`${process.env.PUBLIC_URL}/images/sns-03.png`}
                                    alt='twitter icon'
                                />
                            </a>
                        </div>
                        <div className='max-w-[40px]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social Icons',
                                        label: `NIS Discord`,
                                    })
                                }}
                                href='https://discord.gg/nisa'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Discord'
                            >
                                <img
                                    className='w-full'
                                    src={`${process.env.PUBLIC_URL}/images/sns-08.png`}
                                    alt='discord icon'
                                />
                            </a>
                        </div>{' '}
                        <div className='max-w-[40px]'>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social Icons',
                                        label: `NIS Discord`,
                                    })
                                }}
                                href='https://store.steampowered.com/publisher/nisa'
                                target='_blank'
                                rel='noreferrer'
                                data-label='steam'
                            >
                                <img
                                    className='w-full'
                                    src={`${process.env.PUBLIC_URL}/images/sns-04.png`}
                                    alt='steam icon'
                                />
                            </a>
                        </div>
                    </div>{' '}
                    <div>
                        <p className='my-20 text-sm text-center  text-navy font-bold'>
                            ©NIS America, Inc. All rights reserved.
                        </p>{' '}
                    </div>
                </div>{' '}
            </div>
        </>
    )
}
